import { SideMenuService } from './side-menu/side-menu.service';
import { DontHaveSiteGuard } from './../core/authorization/dont-have-site.guard';
import { HasSiteGuard } from './../core/authorization/has-site.guard';
import { TopMenuComponent } from './top-menu/top-menu.component';
import { SideMenuComponent } from './side-menu/side-menu.component';
import { TopLevelSideMenuComponent } from './top-level-side-menu/top-level-side-menu.component';
import { MobileNavComponent } from './mobile-nav/mobile-nav.component';
import { SiteSelectorComponent } from './site-selector/site-selector.component';
import { NavigationItemComponent } from './side-menu/navigation-item/navigation-item.component';
import { NavigationSubItemComponent } from './side-menu//navigation-sub-item/navigation-sub-item.component';
import { NgModule } from '@angular/core';
import { SharedModule } from './../shared/shared.module';
import { LayoutComponent } from './layout.component';
import { ErrorComponent } from './../error/error.component';
import { AccountExpiredComponent } from '../account-expired/account-expired.component';
import { FlyoutModule } from '../flyout/flyout.module';
import { AgentsModule } from '../agents/agents.module';
import {
  KNOWLEDGE_NOTIFICATION_PROVIDERS,
  KnowledgeNotificationsModule,
} from '../knowledge/notifications/knowledge-notifications.module';
import { CustomerSelectorComponent } from './customer-selector/customer-selector.component';
import { InactiveAccountBannerComponent } from './inactive-account-banner/inactive-account-banner.component';

const components = [
  TopMenuComponent,
  SideMenuComponent,
  TopLevelSideMenuComponent,
  MobileNavComponent,
  SiteSelectorComponent,
  NavigationItemComponent,
  NavigationSubItemComponent,
  LayoutComponent,
];

@NgModule({
  declarations: [...components, ErrorComponent, AccountExpiredComponent, InactiveAccountBannerComponent],
  exports: [...components, SharedModule],
  imports: [SharedModule, FlyoutModule, AgentsModule, KnowledgeNotificationsModule, CustomerSelectorComponent],
  // The notification providers are registered here rather than on their own module, which is what keeps
  // WebPushService a single instance across the eager bell and the lazy notifications page.
  providers: [SideMenuService, HasSiteGuard, DontHaveSiteGuard, ...KNOWLEDGE_NOTIFICATION_PROVIDERS],
})
export class LayoutModule {}
